import { Controller } from '@hotwired/stimulus';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { BUNDLES_TOAST_CLICK } from 'components/analytics/conversions/constants/actions';
import Cookies from 'js-cookie';

export default class PromoPopupController extends Controller {
  static values = {
    trackTriggerAction: String,
  }

  dismissTimer = null;

  connect() {
    this.setupSessionPopup();
    if (this.element.dataset.dismissTimer) this.setAutoDismiss();

    if (!this.hasTrackTriggerActionValue) return;

    sendTrackingEvent({
      element: this.element,
      data: {
        action: this.trackTriggerActionValue,
        label: this.getResourceType(),
        non_interaction: true,
      },
    });

    window.addEventListener('hidePromoPopup', this.hide);
  }

  getResourceType() {
    const element = document.querySelector('[data-resource-type]');

    if (!element) return 'Other';

    const { resourceType } = element.dataset;

    return resourceType[0].toUpperCase() + resourceType.substring(1).toLowerCase();
  }

  disconnect() {
    window.removeEventListener('hidePromoPopup', this.hide);
  }

  setAutoDismiss = () => {
    this.dismissTimer = setTimeout(() => {
      this.hide();
    }, parseInt(this.element.dataset.dismissTimer, 10));
  }

  close = () => {
    if (this.element.dataset.dismissSessionId) {
      this.setSessionCookie();
    } else if (this.element.classList.contains('bundles-promo')) {
      this.setBundlePopupCookie();
    } else {
      const npsAction = document.querySelector('[data-nps-action]');
      const cookieKey = npsAction ? npsAction.getAttribute('data-nps-action') : 'dismissed_promo_popup';

      Cookies.set(cookieKey, '1');
    }

    this.remove();
    this.element.classList.add('is-hidden');
  }

  hide = () => {
    this.element.classList.add('fade-out');
    this.remove();
  }

  remove = () => {
    if (this.dismissTimer) clearTimeout(this.dismissTimer);

    setTimeout(() => {
      this.element.remove();
    }, 500);
  }

  setupSessionPopup() {
    const sessionId = this.element.dataset.dismissSessionId;
    if (sessionId && sessionStorage.getItem(sessionId) !== '1') {
      this.element.classList.remove('is-hidden');
    }
  }

  setSessionCookie() {
    const sessionId = this.element.dataset.dismissSessionId;
    sessionStorage.setItem(sessionId, '1');
  }

  setBundlePopupCookie() {
    const date = new Date(0);
    date.setUTCSeconds(parseInt(this.element.dataset.cookieExpiration, 10));

    Cookies.set('dismissed_bundles_popup',
      '1',
      {
        domain: this.cookieDomain,
        expires: date,
      });
  }

  sendBundleClick(event) {
    sendTrackingEvent({
      element: event.target,
      data: { action: BUNDLES_TOAST_CLICK },
    });
  }

  get cookieDomain() {
    const cookieDomainArray = window.location.hostname.split('.');
    return `${cookieDomainArray[1]}.${cookieDomainArray[2]}`;
  }
}
